if (!customElements.get('ra-weekend-copy')) {
  customElements.define('ra-weekend-copy', class extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        clearTimeout(this.timer);
        const now = Date.now();
        const start = Date.parse('2026-10-02T13:00:00Z');
        const end = Date.parse('2026-10-04T21:59:00Z');
        const state = String(this.dataset.eligible === 'true' && now >= start && now < end);
        if (this.dataset.active !== state) this.dataset.active = state;
        const next = now < start ? start : now < end ? end : null;
        if (next && this.dataset.eligible === 'true') this.timer = setTimeout(this.refresh, Math.min(next - now + 100, 2147483647));
      };
      this.refresh();
      document.addEventListener('visibilitychange', this.refresh);
      window.addEventListener('pageshow', this.refresh);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('visibilitychange', this.refresh);
      window.removeEventListener('pageshow', this.refresh);
    }
  });
}
